/** Badge colours for initials avatars (event-group palette), used by the reviews grid. */
export const avatarColors = ['bg-clay', 'bg-lane', 'bg-infield', 'bg-amber', 'bg-navy-line', 'bg-clay-deep']
